import { Document, Page, Text, View } from "@react-pdf/renderer";
import React from "react";
import { styles } from "../../style";

const Page4 = () => {
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.spaceY}>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.3.2. {""}</Text>
            <Text style={styles.subtext}>
              Эрх олгогчийн хүлээлгэн өгсөн уран бүтээл, уран бүтээлийн зураг,
              дүрс бичлэгийг өөрийн суваг, брендийг сурталчлах зорилгоор
              ашиглах;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.3.3. {""}</Text>
            <Text style={styles.subtext}>
              Эрх олгогчийн уран бүтээлийг аль сувгуудад байршуулахтай холбоотой
              асуудлыг шийдвэрлэх;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.3.4. {""}</Text>
            <Text style={styles.subtext}>
              М Мюзик Дистрибюшн нь өөрийн үйлчилгээнүүд, Эрх олгогчийн уран
              бүтээлийн борлуулалтыг дэмжих, Эрх олгогч болон зохиогчийг
              сурталчлах зорилгоор Уран бүтээлийг хэсэгчлэн ашиглах;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.3.5. {""}</Text>
            <Text style={styles.subtext}>
              Эрх олгогчийг Гэрээ болон хууль тогтоомжид заасан бусад үүргийг
              биелүүлэхийг шаардах.
            </Text>
          </View>
        </View>
        <View style={styles.spaceX}>
          <Text>4.4.</Text>
          <Text style={styles.text}>М Мюзик Дистрибюшний үүрэг</Text>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.4.1. {""}</Text>
            <Text style={styles.subtext}>
              Уран бүтээлийг өөрийн болон бусад сувгаар дамжуулан нийтэд түгээх,
              түрээслүүлэхдээ Эрх олгогчийн нэр хүнд, ашиг сонирхлыг
              хөндөхгүйгээр нийтэд түгээх, түрээслүүлэх;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.4.2. {""}</Text>
            <Text style={styles.subtext}>
              Эрх олгогчид Уран бүтээлийг хэрэглэгчид түгээсэн, түрээсэлсэн,
              борлуулсан борлуулалтын тоо баримтын мэдээ, мэдээллээр хангах;
            </Text>
          </View>
        </View>
        <View style={styles.subListItem}>
          <View style={styles.spaceX}>
            <Text>4.4.3. {""}</Text>
            <Text style={styles.subtext}>
              Гэрээнд заасан үйлчилгээг үзүүлэхдээ Эрх олгогчийн Уран бүтээлийн
              эх хувийн аюулгүйн байдлыг хангаж, зөвшөөрөлгүй ашиглахаас
              урьдчилан сэргийлэх зорилгоор технологийн өндөр хамгаалалтаар
              хангаж ажиллах;
            </Text>
          </View>
        </View>
      </View>
      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 8 },
          ]}
        >
          ТАВ.ГЭРЭЭНИЙ НУУЦЛАЛ
        </Text>
      </View>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>5.1.</Text>
          <Text style={styles.text}>
            Талууд энэхүү Гэрээг байгуулсантай холбоотой Гэрээг хэрэгжүүлэх
            явцад шууд болон шууд бусаар олж мэдсэн байгууллага, хувь хүний
            нууцад хамааралтай мэдээ, баримт бичиг, гэрээ, харилцан яриа,
            бичлэг, зохиогчийн эрх, арга техник, үйлчилгээний бодлого болон
            бусад хамаарал бүхий бүх төрлийн мэдээ, мэдээллийг гуравдагч
            этгээдэд бичиг болон аман хэлбэрээр задруулахгүй байх үүргийг
            хугацаагүйгээр хүлээнэ.
          </Text>
        </View>
      </View>

      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 8 },
          ]}
        >
          ЗУРГАА.ДАВАГДАШГҮЙ ХҮЧИН ЗҮЙЛ
        </Text>
      </View>
      <View style={styles.spaceY}>
        <View style={styles.spaceX}>
          <Text>6.1.</Text>
          <Text style={styles.text}>
            Гэнэтийн буюу давагдашгүй хүчин зүйлс гэдэгт гал, түймэр, үер, хуй
            салхи, шуурга, аянга цахилгаан зэрэг байгалийн гамшиг, дайн
            байлдаан, нийтийг хамарсан үймээн самуун, эсэргүүцлийн хөдөлгөөн,
            халдварт өвчин, хорио цээр зэрэг Талуудын хүсэл зоригоос үл хамаарах
            нөхцөлүүдийг хамааруулна.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>6.2.</Text>
          <Text style={styles.text}>
            Гэрээний аль нэг тал давагдашгүй хүчин зүйлийн улмаас гэрээгээр
            хүлээсэн үүргээ биелүүлэх боломжгүй болсон тохиолдолд гэрээний
            хариуцлагаас чөлөөлөгдөх үндэслэл болно.
          </Text>
        </View>
        <View style={styles.spaceX}>
          <Text>6.3.</Text>
          <Text style={styles.text}>
            Гэнэтийн болон давагдашгүй хүчин зүйлсийн улмаас аль нэг тал нь
            Гэрээгээр хүлээсэн үүргээ биелүүлэх боломжгүй болсон тохиолдолд энэ
            тухай нөгөө талдаа даруй мэдэгдэнэ.
          </Text>
        </View>
      </View>
      <View style={styles.header}>
        <Text
          style={[
            styles.title,
            styles.textBold,
            { letterSpacing: 0.2, marginTop: 8 },
          ]}
        >
          ДОЛОО.ХАРИУЦЛАГА
        </Text>
      </View>
      <View style={styles.spaceX}>
        <Text>7.1.</Text>
        <Text style={styles.text}>
          Энэхүү Гэрээний аль нэг тал нь Гэрээгээр хүлээсэн үүргээ биелүүлээгүйн
          улмаас нөгөө талдаа эдийн болон эдийн бус хохирол учруулсан бол
          тийнхүү учруулсан хохирлыг үл маргах журмаар нөхөн төлөх үүрэгтэй.
        </Text>
      </View>
    </Page>
  );
};

export default Page4;
